























import { Component, Vue } from 'vue-property-decorator';
import Teacher from '@/services/Teacher';
import Module from '@/components/global/Module.vue';
import { IModule, IRefModule } from '@/models/Modules';
import { IClass } from '@/models/Classes';
import { Teacher as ITeacher } from '@/models/Teachers';
import Classroom from '@/services/Classroom';
import Modules from '@/services/Modules';

@Component({
  components: {
    Module,
  },
})
export default class AddModule extends Vue {
  public teacher: ITeacher | null = null;
  public modules: IModule[] = [];
  public selectedModuleRefs: IRefModule[] = [];
  public modulesLookup: IModule[] = [];
  public classroomId = '';

  async mounted() {
    this.classroomId = this.$route.params.id;
    const classroom: IClass | null = (await Classroom.getClassroomById(this.classroomId)) as IClass;
    this.teacher = await Teacher.getLoggedInTeacher();
    if (!this.teacher) {
      return;
    }

    this.modulesLookup = (
      await Modules.getModulesObserverByTeacherEmail(this.teacher.email).get()
    ).docs.map(d => ({ ...d.data(), id: d.id })) as IModule[];

    if (classroom) {
      this.selectedModuleRefs = classroom.modules as IRefModule[];
    }

    this.modules = this.teacher?.modules.reduce((all, mId) => {
      const module = this.modulesLookup.find(m => m.id === mId);
      if (module) {
        all.push(module);
      }
      return all;
    }, [] as IModule[]);
  }

  selectModule(moduleId: string) {
    const ref = this.selectedModuleRefs.find(ref => ref.id === moduleId);
    if (ref) {
      const index = this.selectedModuleRefs.indexOf(ref);
      this.selectedModuleRefs.splice(index, 1);
    } else {
      this.selectedModuleRefs.push({
        id: moduleId,
        locked: false,
      });
    }
  }

  isSelected(moduleId: string) {
    const ref = this.selectedModuleRefs.find(ref => ref.id === moduleId);
    return !!ref;
  }

  async addModules() {
    await Classroom.updateClassRoomModuleOrder(this.$route.params.id, this.selectedModuleRefs);
    this.closeModal();
  }

  closeModal() {
    this.$parent.$emit('close-modal');
  }
}
